import React, { Component } from "react";
import { Card, ModalBody, ModalHeader, ModalNext, withModalContext } from "@jutro/components";
import { MetadataContent } from "@jutro/uiconfig";
import BodilyInjuryMetadata  from "./PolicyCoverages/BodilyInjury.metadata.json5";
import PropertyDamageMetadata from "./PolicyCoverages/PropertyDamage.metadata.json5";
import AccidentWaiver from "./PolicyCoverages/AccidentWaiver.metadata.json5";
import AccidentalDeath from "./PolicyCoverages/AccidentalDeath.metadata.json5";
import MedicalPayments from "./PolicyCoverages/MedicalPayments.metadata.json5";
import UninsuredMotoristBI from "./PolicyCoverages/UninsuredMotoristBI.metadata.json5";
import UninsuredMotoristDeductible from "./PolicyCoverages/UninsuredMotoristDeductible.metadata.json5";
import UninsuredMotoristPD from "./PolicyCoverages/UninsuredMotoristPD.metadata.json5";
import ComprehensiveMetadata from "./VehicleCoverages/ComprehensiveCoverage.metadata.json5"
import RoadsideAssistance from "./VehicleCoverages/RoadsideAssistance.metadata.json5";
import LossOfUse from "./VehicleCoverages/LossOfUse.metadata.json5";
import LossOfIncome from "./VehicleCoverages/LossOfIncome.metadata.json5";
import CollisionDeductible from "./VehicleCoverages/CollisionDeductible.metadata.json5";
import LeaseLoan from "./VehicleCoverages/LeaseLoan.metadata.json5";
import styles from "./Coverages.module.scss";

class CoveragesPopUp extends Component {
  state = {};

  handleDismiss = (evt) => {
    // eslint-disable-next-line react/prop-types
    const { onResolve } = this.props;
    evt.stopPropagation();
    onResolve();
  };

  amountSelected = (publicID, value) => {
    let amountTag= '';
    if(publicID === 'PAUninsuredMotoristCommon_alfa' || publicID === 'PAComprehensiveCov' || publicID === 'PACollisionCov'){
        amountTag = <p>Deductible Selected: <span className={styles.amountStyle}>{this.appendDollar(value)}</span></p>;
    } else {
        amountTag = <p>Amount Selected: <span className={styles.amountStyle}>{this.appendDollar(value)}</span></p>;
    }
      return amountTag;
  }

  appendDollar(value) {
  const substrings = ["Included", "Not Included", "Added on", "Reduced"];

  if (substrings.some(substring => value.includes(substring))) {
    return value;
  }

  if (value.includes("/")) {
    return value.split("/").map(part => `$${part.trim()}`).join(" / ");
  }

  return `$${value}`;
}

  setMetadata = (publicID) => {
    switch (publicID) {
      case "PABI_alfa":
        return BodilyInjuryMetadata.componentContent;

      case "PAPropertyDamage_alfa":
        return PropertyDamageMetadata.componentContent;

      case "PAAccidentWaiver_alfa":
        return AccidentWaiver.componentContent;

      case "PAMedicalPayments_alfa":
        return MedicalPayments.componentContent;

      case "PAADD_alfa":
        return AccidentalDeath.componentContent;

      case "PAUninsuredMotoristBI_alfa":
        return UninsuredMotoristBI.componentContent;

      case "PAUninsuredMotoristPD_alfa":
        return UninsuredMotoristPD.componentContent;

      case "PAUninsuredMotoristCommon_alfa":
        return UninsuredMotoristDeductible.componentContent;

      case "PAComprehensiveCov":
        return ComprehensiveMetadata.componentContent;

      case "PATowingLaborCov":
        return RoadsideAssistance.componentContent;

      case "PACollisionCov":
        return CollisionDeductible.componentContent;

      case "PALossOfUseCov_alfa":
        return LossOfUse.componentContent;

      case "PALossOfIncome_alfa":
        return LossOfIncome.componentContent;

      case "PALeaseLoan_alfa":
        return LeaseLoan.componentContent;
    }
  }

  render() {
    // eslint-disable-next-line react/prop-types
    const { modalId, value, name } = this.props;
    const overrides = {
      cancel: {
        content: "Got It",
        visible: "true",
      },
      amountHeader: {
        content: this.amountSelected(modalId, value),
      },
      deductibleHeader: {
        content:
          name === "Uninsured Motorist - Reduced or Added On"
            ? "Uninsured Motorist -  Reduced or Added On"
            : "Uninsured Motorist -  Deductible",
      },
      addOnReduced: {
        visible: name === "Uninsured Motorist - Reduced or Added On" ? true : false,
      },
      deductible: {
        visible: name === "Uninsured Motorist - Deductible" ? true : false,
      },
    }

    const metadata = this.setMetadata(this.props.modalId)

    const resolvers = {
      resolveCallbackMap: {
        onCancel: this.handleDismiss,
      },
      resolveClassNameMap: styles,
    };

    return (
      <ModalNext isOpen={this.props.isOpen}>
        <ModalBody>
          <Card id="standardizedPanel" className={styles.policyCoverageStyle}>
            <MetadataContent
              uiProps={metadata}
              overrideProps={overrides}
              {...resolvers}
            />
        </Card>
        </ModalBody>
      </ModalNext>
    );
  }
}

export default withModalContext(CoveragesPopUp);
